import { useQuery } from '@tanstack/react-query';
import { getPatientDocuments, PatientDocumentType } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';


export const usePatientDocumentsQuery = (patientId: string, documentTypes?: PatientDocumentType[], opts?: BaseQueryOpts) => {
  return useQuery([ 'user', patientId, 'documents', documentTypes ], async () => {
    const patientDocuments = await getPatientDocuments(patientId, documentTypes);

    return patientDocuments.data;
  }, opts);
};
